import addRoute from '@/router/add-route';

const Blacklists = () => import('@/modules/blacklists/blacklists.vue');
const BlacklistForm = () => import('@/modules/blacklists/blacklist-form.vue');

const blacklists = [
    addRoute({
        name: 'blacklists',
        path: '/blacklists/:type?',
        component: Blacklists,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'add-blacklist',
        path: '/blacklists/add/:type?/:continue?',
        component: BlacklistForm,
        root: {label: 'Automations', name: 'automations'},
    }),
];

export default blacklists;
